import { defineMessages } from 'react-intl';


const documentsMessages = defineMessages({
    addNewPermit: {
        id: 'add-new-permit',
        defaultMessage: 'Add new permit',
    },
});

export default documentsMessages;
